var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cc_icon_thermometer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,70C8.2,70,0,62.3,0,52.8c0-5,2.1-9.1,4.9-12.4v-28C4.9,5.3,10.6,0,17.1,0s12.2,5.8,12.2,12.4v27.7 c2.9,3.3,4.9,7.3,4.9,12.4C34.7,62.3,26.8,70,17.5,70z M24.9,42.4V12.5c0-4.2-3.3-7.5-7.4-7.5c-4,0-7.2,3.3-7.2,7.5v29.9 c-2.9,2.5-4.9,5.8-4.9,10c0,7,5.7,12.4,12.2,12.4s12-5.8,12-12.4C29.7,48.6,28.2,44.9,24.9,42.4z M17.5,60.2c-4,0-7.2-3.3-7.2-7.3 c0-3.3,1.9-6.2,4.7-7.1V30.7H20v15c2.9,1.4,4.9,4.2,4.9,7.1C24.9,56.9,21.7,60.2,17.5,60.2z M40,14h-7.8V9.9h7.2V14H40z M40,23.8 h-7.8v-3.7h7.2v3.7H40z M40,33.9h-7.8V30h7.2v3.9H40z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.cca865874fdb23037a809bca6a7c48ba.svg";
export { ForwardRef as ReactComponent };